import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 px-6 lg:px-10 py-14 md:py-20 scroll-mt-24">
      <SectionHeading
        index="07"
        label="FAQ"
        title="关于「有什么好看的」的常见问答"
        desc="第一次来常见的问题，都放在这里，看完大概就知道该从哪里开始了。"
      />

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-3">
        {faqs.map((faq, i) => {
          const open = openIndex === i;
          return (
            <div
              key={faq.q}
              className="rounded-lg bg-background-100 border border-background-200 overflow-hidden"
            >
              <button
                type="button"
                onClick={() => setOpenIndex(open ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-[15px] font-medium text-foreground-950">
                  {faq.q}
                </span>
                <i
                  className={`shrink-0 text-[20px] text-primary-500 transition-transform ${
                    open ? "ri-subtract-line" : "ri-add-line"
                  }`}
                ></i>
              </button>
              {open && (
                <p className="px-5 pb-5 -mt-1 text-sm leading-relaxed text-foreground-600">
                  {faq.a}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}